import React, { useState, useCallback , useEffect} from 'react';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { EntryPageTemplate } from 'gw-components-platform-react';
import { Loader } from '@jutro/components';
import { useAuthentication } from 'gw-digital-auth-react';

import metadata from './UserRegisterEntryPage.metadata.json5';

const VIEWS = {
    logInView: 'LOG_IN_VIEW',
    forgotPasswordView: 'FORGOT_PASSWORD_VIEW',
    initLandingView: 'INIT_LANDING',
    userEnrollView: 'USER_ENROLL_VIEW'
};

const { applicationDetails } = appConfig;

function UserRegisterEntryPage({ location}) {
    const { isAuthInProgress } = useAuthentication();
    const [view, updateView] = useState(VIEWS.userEnrollView);
    
    const { state } = location;


    const handleForgotPasswordClick = useCallback(() => {
        updateView(VIEWS.forgotPasswordView);
    }, []);

    const handleSignInClick = useCallback(() => {
        updateView(VIEWS.logInView);
    }, []);

    const handleInitLandingClick = useCallback(() => {
        updateView(VIEWS.logInView);
    }, []);

    const handleUserEnrollClick = useCallback(() => {
        updateView(VIEWS.userEnrollView);
    }, []);

    const handleBackToLandingClick = useCallback(() => {
        updateView(VIEWS.initLandingView);
    }, []);

    if (isAuthInProgress) {
        return <Loader loaded={!isAuthInProgress} />;
    }

    const overrideProps = {
        gwLoginComponent: {
            successPath: _.get(state, 'from.pathname') || '/'
        },
        logInViewContainer: {
            visible: view === VIEWS.logInView
        },
        forgotPasswordViewContainer: {
            visible: view === VIEWS.forgotPasswordView
        },
        initLandingContainer: {
            visible: view === VIEWS.initLandingView
        },
        gwSignUpContainer: {
            visible: view === VIEWS.userEnrollView
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onForgotPasswordClick: handleForgotPasswordClick,
            onSignInClick: handleSignInClick,
            onInitLandingClick: handleInitLandingClick,
            onUserEnrollClick: handleUserEnrollClick,
            onBackToInitialLandingClick: handleBackToLandingClick
        }
    };

    const renderedContentFromMetadata = renderContentFromMetadata(
        metadata.pageContent,
        overrideProps,
        resolvers
    );

    return (
        <EntryPageTemplate
            applicationName={applicationDetails.applicationName}
            applicationLogo={applicationDetails.applicationLogo}
            contentToRender={renderedContentFromMetadata}
        />
    );
}

UserRegisterEntryPage.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({})
    })
};

UserRegisterEntryPage.defaultProps = {
    location: {}
};

export default UserRegisterEntryPage;
